import styled from 'styled-components';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../context/UserContext';
import ConfirmModal from './ConfirmModal';
import UserService from '../../service/User';
import PageTop from '../components/pageTop/PageTop';
import Menu from '../components/menu/Menu';

const ChangePassword = () => {
  const [currentPw, setCurrentPw] = useState('');
  const [newPw, setNewPw] = useState('');
  const [newPwCheck, setNewPwCheck] = useState('');
  const [showCurrentPw, setShowCurrentPw] = useState(false);
  const [showNewPw, setShowNewPw] = useState(false);
  const [showNewPwCheck, setShowNewPwCheck] = useState(false);
  const [openConfirmModal, setOpenConfirmModal] = useState(false);
  const [openMenu, setOpenMenu] = useState(false);

  const navigate = useNavigate();
  const { user } = useUser();

  // 비밀번호 유효성 검사
  const isPasswordValid = (password: string) => {
    const regex =
      /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!@#$%*&?])[A-Za-z\d!@#$%*&?]{8,16}$/;
    return regex.test(password);
  };

  const isMatchingPasswords = newPw === newPwCheck;

  const isDisabled =
    currentPw === '' || !isPasswordValid(newPw) || !isMatchingPasswords;

  const ChangePw = async () => {
    try {
      const data = {
        userid: user?.userid,
        password: currentPw,
        newpassword: newPw,
      };
      const res = await UserService.changePassword(data);
      setOpenConfirmModal(true);
    } catch (error) {
      console.error('changePw 함수에서 에러 발생:', error);
    }
  };

  const handleApply = () => {
    window.confirm('비밀번호를 변경하시겠습니까?') && ChangePw();
  };

  return (
    <Container>
      <PageTop text="비밀번호 변경" setOpenMenu={setOpenMenu} />
      <Inner>
        <ContentBox>
          <Block>
            <div>현재 비밀번호</div>
            <InputBox>
              <Input
                type={showCurrentPw ? 'text' : 'password'}
                placeholder="현재 비밀번호를 입력해주세요."
                value={currentPw}
                onChange={(e) => setCurrentPw(e.target.value)}
              />
              <EyeIconImg
                src={`/assets/images/icon/${showCurrentPw ? 'Visible' : 'notVisible'}_icon.svg`}
                alt="비밀번호 보이기"
                onClick={() => setShowCurrentPw(!showCurrentPw)}
              />
            </InputBox>
          </Block>
          <Block>
            <div>비밀번호</div>
            <InputBox>
              <Input
                type={showNewPw ? 'text' : 'password'}
                placeholder="비밀번호를 입력해주세요."
                value={newPw}
                onChange={(e) => setNewPw(e.target.value)}
              />
              <EyeIconImg
                src={`/assets/images/icon/${showNewPw ? 'Visible' : 'notVisible'}_icon.svg`}
                alt="비밀번호 보이기"
                onClick={() => setShowNewPw(!showNewPw)}
              />
            </InputBox>

            <InputBox>
              <Input
                type={showNewPwCheck ? 'text' : 'password'}
                placeholder="비밀번호 확인"
                value={newPwCheck}
                onChange={(e) => setNewPwCheck(e.target.value)}
              />
              <EyeIconImg
                src={`/assets/images/icon/${showNewPwCheck ? 'Visible' : 'notVisible'}_icon.svg`}
                alt="비밀번호 보이기"
                onClick={() => setShowNewPwCheck(!showNewPwCheck)}
              />
            </InputBox>

            <Description>
              <img src="/assets/images/icon/info-gray.svg" alt="" />
              <div>
                8~16자의 영문, 숫자, 특수문자를 조합하여 입력해주세요. <br />
                (사용 가능한 특수문자 ! ? @ # $ % * &)
              </div>
            </Description>
          </Block>
        </ContentBox>
        <ButtonBox>
          <CancelButton
            onClick={() => {
              localStorage.setItem('mypageTab', 'myinfo');
              navigate('/mypage');
            }}
          >
            취소
          </CancelButton>
          <ApplyButton disabled={isDisabled} onClick={handleApply}>
            비밀번호 변경
          </ApplyButton>
        </ButtonBox>
      </Inner>
      {openConfirmModal && (
        <ConfirmModal
          type="confirm"
          title="비밀번호 변경 완료"
          text="비밀번호 변경이 완료되었습니다."
          buttonText="확인"
          onClick={() => {
            setOpenConfirmModal(false);
            navigate('/mypage');
            sessionStorage.setItem('mypageTab', 'myinfo');
          }}
        />
      )}
      {openMenu && <Menu page="changePassword" setOpenMenu={setOpenMenu} />}
    </Container>
  );
};

export default ChangePassword;

const Container = styled.div`
  max-width: 900px;
  min-height: 100vh;
  margin: 0 auto;
  box-shadow: 0 0 20px hsla(0, 0%, 51%, 0.15);
  position: relative;
  font-family: Spoqa Han Sans Neo;
  display: flex;
  flex-direction: column;
`;

const Inner = styled.div`
  width: 100%;
  padding: 24px 16px 40px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  flex-grow: 1;
`;
const ContentBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const Block = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 700;
  color: #222;
`;
const InputBox = styled.div`
  width: 100%;
  height: 50px;
  border-radius: 8px;
  background: #f5f7fa;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px;
`;
const Input = styled.input`
  border: none;
  background: none;
  flex: 1;
  outline: none;
`;
const Description = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 6px;
  justify-content: flex-start;
  align-items: flex-start;
  font-family: Spoqa Han Sans Neo;
  font-size: 14px;
  font-weight: 500;
  color: rgba(55, 56, 60, 0.61);
`;
const ButtonBox = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 8px;
`;
const CancelButton = styled.button`
  width: 108px;
  height: 50px;
  border-radius: 8px;
  background: rgba(112, 115, 124, 0.08);
  color: #616161;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

const ApplyButton = styled.button`
  flex: 1;
  height: 50px;
  border-radius: 8px;
  background: ${({ disabled }) =>
    disabled ? 'rgba(112, 115, 124, 0.08)' : '#008AFF'};
  color: ${({ disabled }) => (disabled ? 'rgba(55, 56, 60, 0.16)' : '#fff')};
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: Spoqa Han Sans Neo;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  border: none;
`;

const EyeIconImg = styled.img`
  cursor: pointer;
`;
